// src/env.ts

// Helper to detect Vite's injected import.meta.env
function getEnv(): Record<string, string | undefined> {
  // Vite: import.meta.env is available in the browser
  if (typeof import.meta !== "undefined" && import.meta.env) {
    // Vite: returns an object with all VITE_ variables
    // (and some NODE_ENV, BASE_URL, MODE, etc)
    // @ts-expect-error
    return import.meta.env;
  }

  // Node.js: fallback to process.env
  if (typeof process !== "undefined" && process.env) {
    return process.env;
  }

  // Fallback: empty object
  return {};
}

export const env = getEnv();
